import apiPaths from '../api-paths';

export default {
  listKpirIncomeColumns() {
    return axios.get(`${ apiPaths.BOOKKEEPING }/kpir/columns/income`);
  },
  listKpirDeductionColumns() {
    return axios.get(`${ apiPaths.BOOKKEEPING }/kpir/columns/deduction`);
  },
  listRyczaltRates() {
    return axios.get(`${ apiPaths.BOOKKEEPING }/ryczalt/rates`);
  },
  listVatRegisterTypes() {
    return axios.get(`${ apiPaths.BOOKKEEPING }/vat-register-types`);
  },
};
